import React from "react";
import { Link } from "react-router-dom";
import { Truncate } from "@re-dev/react-truncate";
import { FaEdit, FaLink } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FaBoxOpen } from "react-icons/fa";
import { ListingStatusIcon } from "./ListingStatusIcon";
import { ListingActionsMenu } from "./ListingActionsMenu";
import { useIndexPageData } from "../../../contextapi/Indexpagedata";
import { isBundleListing } from "../utils/helpers";

export const GridListingCard = ({
  item,
  isLargeScreen,
  menuAnchor,
  selectedItemId,
  selectionModeActive = false,
  selectedListingIds = [],
  selectedBundleIds = [],
  isSelectedAll = false,
  onToggleSelect,
  onMenuClick,
  onMenuClose,
  onEdit,
  onDelete,
  onOpenBundle,
  onSharableLink,
  onPublishModal,
  showMoveToFolder = false,
  onMoveToFolderClick,
  showRemoveFromFolder = false,
  onRemoveFromFolderClick,
  openBundleAsLink = false,
}) => {
  const { profiledata } = useIndexPageData();
  const isBundle = isBundleListing(item);
  const isMockup = !isBundle;
  const showCheckbox = selectionModeActive;
  const isSelected = isMockup
    ? (isSelectedAll || selectedListingIds.includes(item?.id))
    : selectedBundleIds.includes(item?.id);

  const getThumbnailSrc = () => {
    if (isBundle) {
      return item?.bundle_thumbnails?.[0]?.image;
    }
    return item?.use_main_file_as_thumbnail
      ? item?.compressed_file
      : item?.thumbnails?.[0]?.image;
  };

  return (
    <div className=" col-6 col-lg-3 mb-4">
      <div className="listing-card card shadow p-2 position-relative">
        <div className="listing-img overflow-hidden">
          {isBundle ? (
            openBundleAsLink ? (
              <Link
                to={`/bundle?id=${item?.id}`}
                className="card-img-wrapper position-relative d-block"
              >
                <img
                  src={getThumbnailSrc()}
              
                  className="card-img-top rounded-tr-lg"
                  alt="Product 1"
                />
                {!selectionModeActive && (
                  <ListingStatusIcon
                    item={item}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onMenuClick(e, item);
                    }}
                  />
                )}
                <div
                  className="position-absolute z-3"
                  style={{
                    top: "10px",
                    right: "10px",
                    backgroundColor: "#C93312",
                    color: "white",
                    borderRadius: "50%",
                    width: "50px",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                  }}
                >
                  <img
                    src="../../../assets/images/BundleIcon-removebg-preview.png"
                    alt="bundle icon"
                    style={{
                      width: "25px",
                      height: "25px",
                      objectFit: "contain",
                      borderRadius: "50%",
                    }}
                  />
                </div>
              </Link>
            ) : (
            <div
              className="card-img-wrapper position-relative cursor-pointer"
              onClick={() => onOpenBundle(item?.id)}
            >
              <img
                src={getThumbnailSrc()}
             
                className="card-img-top rounded-tr-lg"
                alt="Product 1"
              />
              {!selectionModeActive && (
                <ListingStatusIcon
                  item={item}
                  onClick={(e) =>{
                    e.stopPropagation();
                    onMenuClick(e, item);
                  }}
                />
              )}
              <div
                className="position-absolute z-3"
                style={{
                  top: "10px",
                  right: "10px",
                  backgroundColor: "#C93312",
                  color: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                }}
              >
                <img
                  src="../../../assets/images/BundleIcon-removebg-preview.png"
                  alt="bundle icon"
                  style={{
                    width: "25px",
                    height: "25px",
                    objectFit: "contain",
                    borderRadius: "50%",
                  }}
                />
              </div>
            </div>
            )
          ) : (
            <div className="position-relative card-img-wrapper cursor-pointer">
              <Link to={`/mockup?id=${item.id}`} className="card-img-wrapper">
                <img
                  src={getThumbnailSrc()}
                  className="card-img-top rounded-tr-lg"
                  alt="Product 1"
                />
              </Link>
              {!selectionModeActive && (
                <ListingStatusIcon
                  item={item}
                  onClick={(e) => onMenuClick(e, item)}
                />
              )}
            </div>
          )}

          <ListingActionsMenu
            anchorEl={menuAnchor}
            open={selectedItemId === item.id}
            onClose={onMenuClose}
            item={item}
            onPublish={onPublishModal}
            onUnpublish={onPublishModal}
            onRequestUnblock={onPublishModal}
            onEnableSharableLink={onPublishModal}
            onDisableSharableLink={onPublishModal}
            showMoveToFolder={showMoveToFolder}
            onMoveToFolderClick={onMoveToFolderClick}
            onEdit={onEdit}
          />
        </div>
        {showCheckbox && (
          <div
            className="position-absolute top-1 left-0 m-2 z-2"
            style={{ zIndex: 2 }}
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="checkbox"
              className="form-check-input border-2"
              checked={isSelected}
              onChange={() => onToggleSelect?.(item?.id, isBundle)}
              aria-label={`Select ${item?.title}`}
            />
          </div>
        )}

        <div
          className="listing-content pt-2"
          style={{
            minHeight: isLargeScreen ? "100px" : "109px",
          }}
        >
          <h5 className="testelips fw-bold d-none d-lg-block">{item?.title}</h5>
          <p className="card-title text-start mb-1 testelips d-lg-none">
            {item?.title}
          </p>
          <Truncate
            lines={2}
            style={{ fontSize: "14px" }}
            className="d-none d-lg-block"
          >
            {item?.short_description}
          </Truncate>
          <Truncate
            lines={3}
            style={{ fontSize: "13px" }}
            className="d-lg-none"
          >
            {item?.short_description}
          </Truncate>
        </div>

        {showRemoveFromFolder && onRemoveFromFolderClick && (
          <div className="px-1 mb-2">
            <button
              type="button"
              className="seller-listing-card__folder-action"
              onClick={() => onRemoveFromFolderClick(item?.id, isBundle)}
            >
              Remove from folder
            </button>
          </div>
        )}

        <div className="listing-footer seller-listing-card__actions mb-2">
          {isBundle ? (
            <>
              {openBundleAsLink ? (
                <Link
                  to={`/bundle?id=${item?.id}`}
                  className="seller-listing-card__primary-action text-decoration-none"
                >
                  <FaBoxOpen aria-hidden="true" />
                  <span>Open</span>
                </Link>
              ) : (
                <button
                  type="button"
                  onClick={() => onOpenBundle(item?.id)}
                  className="seller-listing-card__primary-action"
                >
                  <FaBoxOpen aria-hidden="true" />
                  <span>Open</span>
                </button>
              )}
              <button
                type="button"
                className="seller-listing-card__icon-action"
                onClick={() => onEdit(item)}
                aria-label={`Edit ${item?.title || "bundle"}`}
                title="Edit bundle"
              >
                <FaEdit aria-hidden="true" />
              </button>
              <button
                type="button"
                className="seller-listing-card__icon-action seller-listing-card__icon-action--danger"
                onClick={() => onDelete(item?.id, true)}
                aria-label={`Delete ${item?.title || "bundle"}`}
                title="Delete bundle"
              >
                <MdDelete aria-hidden="true" />
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="seller-listing-card__primary-action"
                onClick={() => onEdit(item)}
              >
                <FaEdit aria-hidden="true" />
                <span>Edit</span>
              </button>
              <button
                type="button"
                className="seller-listing-card__icon-action seller-listing-card__icon-action--danger"
                onClick={() => onDelete(item?.id)}
                aria-label={`Delete ${item?.title || "listing"}`}
                title="Delete listing"
              >
                <MdDelete aria-hidden="true" />
              </button>
              {profiledata && profiledata?.is_seller_pro_active && (
                <button
                  type="button"
                  className="seller-listing-card__icon-action seller-listing-card__icon-action--link"
                  disabled={!item?.sharable_link_enabled}
                  aria-label="Copy sharable link"
                  title={
                    item?.sharable_link_enabled
                      ? "Copy sharable link"
                      : "Enable sharable link from the status menu first"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!item?.sharable_link_enabled) return;
                    onSharableLink(e, item?.id, item?.sharable_link_id);
                  }}
                >
                  <FaLink aria-hidden="true" />
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
